<template>
    <div class="page-content page-container">
        <aside class="content-summary">
            <ul>
                <li class="" v-for="i in 3" :key="i">
                    <a :href="`#block-${i}`">
                        &mdash;
                        {{ $t(`home.menuItem${i}`) }}
                    </a>
                </li>
            </ul>
        </aside>

        <section class="content-blocks grid grid-cols-1 gap-700">
            <div
                class="content-block grid grid-cols-1"
                v-for="i in 3"
                :key="i"
                :id="`block-${i}`"
            >
                <SectionHeading v-html="$t(`home.intro${i}Title`)" />
                <SectionSubheading>{{
                    $t(`home.intro${i}Subtitle`)
                }}</SectionSubheading>
                <TextBlock v-html="$t(`home.intro${i}Text`)" />
            </div>
        </section>

        <div></div>
    </div>
</template>

<script>
import SectionHeading from "../typography/SectionHeading";
import SectionSubheading from "../typography/SectionSubheading";
import TextBlock from "../typography/TextBlock";

const { messages } = require("../../i18n/home");

export default {
    name: "Content",
    i18n: { messages },
    components: {
        SectionHeading,
        SectionSubheading,
        TextBlock,
    },
};
</script>

<style scoped>
.page-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: var(--wrapper-padding);
}

.content-block {
    gap: 1rem;
}

.content-summary {
    display: none;

    ul {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 1rem;
        position: sticky;
        top: 4rem;
    }

    li {
        color: #202020;
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1;
        text-transform: uppercase;

        a {
            color: inherit;
            transition: color 0.2s;

            &:hover {
                color: #707070;
            }
        }
    }
}

@media (min-width: 1280px) {
    .page-content {
        grid-template-columns:
            minmax(0, 1fr) min(var(--wrapper-inner-width), 60vw)
            minmax(0, 1fr);
    }

    .content-summary {
        display: block;
    }
}
</style>
